module.exports = __webpack_public_path__ + "media/images/logo@2x-94fa700b97f855246d7313c20d71addd.png";